import React, { useEffect, useState } from 'react';
import { trim } from 'lodash';
import Globalizer from '../../../globalizer';
import translateService from '../../../common/translateService';
import {
  isFastShipping,
  getDeliveryMessage,
  getFastShippingMessage,
  getBookingDays,
  getPreorderDate,
  getComingSoonDate,
} from '../../../services/product/productService';
import productsAvailabilityStatus from './productsAvailabilityStatus';

import './ProductAvailabilityNote.scss';

const ProductAvailabilityNote = (props) => {
  Globalizer.init();

  const [deliveryInfo, setDeliveryInfo] = useState({
    minutesToTodayShipping: 0,
    shippingDate: '',
  });
  const [timeToFastShipping, setTimeToFastShipping] = useState({
    hours: 0,
    minutes: 0,
  });

  async function manageDeliveryInfo() {
    const now = new Date();
    const deliveryInformation = await getDeliveryMessage(now);

    setDeliveryInfo({
      minutesToTodayShipping: deliveryInformation.minutesToTodayShipping,
      shippingDate: deliveryInformation.shippingDate,
    });

    const target =
      deliveryInformation.minutesToTodayShipping > 0
        ? new Date(
            now.getTime() + deliveryInformation.minutesToTodayShipping * 60000,
          )
        : new Date();

    if (deliveryInformation.minutesToTodayShipping > 0) {
      const totalMinutes = Math.floor(
        (target.getTime() - now.getTime()) / 60000,
      );
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      setTimeToFastShipping({
        hours: hours,
        minutes: minutes,
      });

      setInterval(() => {
        updateCountdown(target);
      }, 15000);
    }
  }

  const updateCountdown = (target) => {
    const now = new Date();

    if (now.getTime() <= target.getTime()) {
      const totalMinutes = Math.floor(
        (target.getTime() - now.getTime()) / 60000,
      );
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      setTimeToFastShipping({
        hours: hours,
        minutes: minutes,
      });
    }
  };

  useEffect(() => {
    manageDeliveryInfo();
  }, []);

  return (
    <div
      className={trim(
        `prd-option prd-availability ${props.availabilityStatus}`,
      )}
    >
      <p
        dangerouslySetInnerHTML={{
          __html: translateService.interpolate(
            `productDetail.availabilityNote.${props.availabilityStatus}`,
            {
              qty:
                props.qtyAvailable > 10
                  ? translateService.get(`productDetail.moreThanTen`)
                  : props.qtyAvailable > 5
                  ? translateService.get(`productDetail.moreThanFive`)
                  : props.qtyAvailable,
              shippingMessage: isFastShipping(
                deliveryInfo.minutesToTodayShipping,
              )
                ? getFastShippingMessage(
                    timeToFastShipping.hours,
                    timeToFastShipping.minutes,
                  )
                : deliveryInfo.shippingDate
                ? translateService.interpolate(`productDetail.shippingDate`, {
                    date: Globalizer.formatDateFull(deliveryInfo.shippingDate),
                  })
                : '',
              pathBase: window.$pathBase,
              days:
                props.availabilityStatus ===
                  productsAvailabilityStatus.booking ||
                props.availabilityStatus ===
                  productsAvailabilityStatus.soonAvailable
                  ? getBookingDays(props.option, props.isKit)
                  : '',
              date:
                props.availabilityStatus === productsAvailabilityStatus.preorder
                  ? Globalizer.formatDateShort(
                      getPreorderDate(props.option, props.isKit),
                    )
                  : props.availabilityStatus ===
                    productsAvailabilityStatus.comingSoon
                  ? Globalizer.formatDateShort(
                      getComingSoonDate(props.option, props.isKit),
                    )
                  : '',
            },
          ),
        }}
      />
    </div>
  );
};

export default ProductAvailabilityNote;
